<template>
    <div class="section">
        <div :class="nameClass">{{ sectionName }}</div>
        <div :class="fulfillmentClass">
            <!-- <ProductionViewFulfillment
                v-for="fulfillment of fulfillments"
                :key="fulfillment.id"
                :fulfillment="fulfillment"
                :currentTime="currentTime"
            /> -->
            <FulfillmentBoxComponent
                v-for="fulfillment of fulfillments"
                :key="fulfillment.id"
                :fulfillment="fulfillment"
                :currentTime="currentTime"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { FulfilmentTileSize } from "@/data/model/Enums";
    import type { IExtendedOperatorFulfillment } from "@/data/model/Operator";
    import { computed } from "vue";

    import FulfillmentBoxComponent from "@/operator/components/production/FulfillmentBoxComponent.vue";

    // define props
    const props = defineProps<{
        sectionName: string;
        tileSize: FulfilmentTileSize;
        fulfillments: IExtendedOperatorFulfillment[];
        currentTime: Date;
    }>();

    const isLargeDisplay = computed(() => props.tileSize == FulfilmentTileSize.Large);
    const fulfillmentClass = computed(() => (isLargeDisplay.value ? "fulfillments-large" : "fulfillments"));
    const nameClass = computed(() => (isLargeDisplay.value ? "name-large" : "name"));
</script>

<style lang="scss"></style>
